import { testDriveMember } from "../mockMembers";
import { getMockPolicies } from "../builders/getMockPolicies";

import { MockPersona } from "./mockPersonas.types";

const futurePolicy = getMockPolicies("5R34843-02");

export const jeanLucPicard: MockPersona = {
  key: "jeanLucPicard",
  name: "Jean-Luc Picard",
  description: "🇺🇸 | Future policy, no bills, no HDC",
  providerApiMockResponses: {
    cig: {
      billing: {
        fees: [],
        bills: [],
      },
      policies: {
        usa: futurePolicy,
        canada: [],
      },
    },
    esign: {
      fetchESignDocuments: [],
      createESignRequest: "success",
    },
    insurance: {
      fetchEndorsement: [],
    },
    soul: {
      fetchSoul: {
        hagertyAccounts: {
          myHagertyAccount: {
            id: "1",
            loginEmail: "jeanluc@picard.com",
            firstName: "Jean-Luc",
            middleName: "",
            lastName: "Picard",
            mailingAddress: {
              line1: "805 Defiance St",
              line2: "",
              city: "Wapakoneta",
              state: "OH",
              postalCode: "45895",
              country: "USA",
            },
            preferredPhone: "5678249235",
            salesforceAccounts: [
              {
                accountNumber: "123",
                id: "1",
                partnerId: null,
              },
            ],
            drivetrainAccounts: [
              {
                customerAccountLegacyKey: "000032",
                source: "USA",
                customerSourceSystemKey: "123",
                id: "1",
                partnerCustomerId: "123",
                partnerId: "UNKNOWN",
              },
            ],
            identityAccounts: [],
            message: undefined,
          },
        },
      },
    },
    member: {
      fetchMember: {
        member: {
          member: testDriveMember,
        },
      },
    },
    billing: {
      fetchBilling: {
        bills: {
          bills: [],
          outstandingBalance: 0,
        },
      },
    },
    payments: {
      fetchPayEndorsementUrl: { payEndorsementUrl: "mock-url" },
    },
  },
};
